import React, {Component} from 'react';
import axios from "axios";
import {BubbleLoader} from "react-css-loaders";
import ProductTile from "../components/ProductTile";
import {Button, Col, Row} from "react-bootstrap";
import ProductRow from "../components/ProductRow";
import * as PT from "../global/PortalTools";
import {Session} from "../global/PortalTools";
import Breadcrumbs from "../B2B/Breadcrumbs";
import {ST} from "../global/SystemText";
import {Link} from "react-router-dom";

export default class ServiceProducts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            data: {},
            limit: "",
            sort: "",
            page: 1,
            paginationLimit: 5,
            gridType: "list"
        };

    }

    componentDidMount() {
        let defaultSort = "customer_product_date DESC";
        let defaultPage = 1;
        let defaultLimit = 24;
        this.setState({
            limit: defaultLimit,
            sort: defaultSort,
            page: defaultPage,
        }, this.getMyProducts());


    }

    componentDidUpdate(nextProps, nextState, nextContext) {
        if (!this.state.loaded) {
            this.getMyProducts();
        }
    }

    getMyProducts() {

        axios.get(Session.getItem("endpoint") + 'PortalServlet', {
            params: {
                idMandant: Session.idMandant,
                idCompany:Session.getItem("idCompany"),
                idContact:Session.getItem("idContact"),
                idLanguage:Session.getItem("idLanguage"),
                idCurrency:Session.getItem("idCurrency"),
                priceLevel:Session.getItem("priceLevel"),
                limit: this.state.limit,
                sort: this.state.sort,
                page: this.state.page,
                action: "GET_PORTAL_SERVICE_PRODUCTS"
            }
        })
            .then((response) => {
                this.setState({
                    data: response.data.products,
                    countProducts:response.data.countProducts,
                    loaded: true
                });
            })
            .catch((error) => {
                PT.handleError(error, this.props.history);
            });
    }

    changeLimit(event) {
        this.setState({limit: event.target.value, loaded: false})
    }

    changeSort(event) {
        this.setState({sort: event.target.value, loaded: false})
    }



    render() {

        let pages=Math.ceil(this.state.countProducts/this.state.limit);
        let paginations=[];
        let {page, paginationLimit} = this.state;
        for (let i = 1; i <= pages; i++) {
            if(i === 1 || i === pages){
                paginations.push(<li key={i}>
                    <Button onClick={() => {
                        this.setState({page: i, loaded: false})
                    }} size={"sm"} style={this.state.page === i ? {
                        background: window.portalSettings.portal_pcolor,
                        color: PT.getColorBrightness(window.portalSettings.portal_pcolor) < 135 ? "white" : "#333"
                    } : {}}>{i}</Button>
                </li>);
                continue;
            }
            if(i < (page - paginationLimit)){
                continue;
            }
            if(i > (page + paginationLimit)){
                continue;
            }
            if(i === (page-paginationLimit) || i === (page + paginationLimit)){
                paginations.push(<li key={i}>
                    <Button disabled size={"sm"} style={this.state.page === i ? {
                        background: window.portalSettings.portal_pcolor,
                        color: PT.getColorBrightness(window.portalSettings.portal_pcolor) < 135 ? "white" : "#333"
                    } : {}}>...</Button>
                </li>);
                continue;
            }

            paginations.push(<li key={i}>
                <Button onClick={() => {
                    this.setState({page: i, loaded: false})
                }} size={"sm"} style={this.state.page === i ? {
                    background: window.portalSettings.portal_pcolor,
                    color: PT.getColorBrightness(window.portalSettings.portal_pcolor) < 135 ? "white" : "#333"
                } : {}}>{i}</Button>
            </li>);
        }
        if (this.state.loaded) {
            let tiles = this.state.data;
            if (tiles.length > 0) {
                return (
                    <div className="panel border-top-xlg" style={{borderColor: window.portalSettings.portal_pcolor}}>
                        <Breadcrumbs active={ST.get("serviceProduct", "service")}/>
                        <div className="panel-heading no-padding-bottom">
                            <h3 className="panel-title">{ST.get("serviceProduct", "service")}</h3>
                        </div>
                        <div className="panel-body">
                            <div className="product-toolbox">
                                <div className="row">
                                    <div className="col-lg-4 ">
                                    </div>
                                    <div className="col-lg-8 text-right">
                                        <div className="input-group inline">
                                            <label className="pt-15">{ST.get("show", "global")}:</label>
                                            <select value={Number(this.state.limit)} className="form-control"
                                                    onChange={this.changeLimit.bind(this)}>
                                                <option value={24}>24</option>
                                                <option value={48}>48</option>
                                            </select>
                                        </div>
                                        <div className="input-group inline">
                                            <label className="pt-15">{ST.get("order_by", "global")}:</label>
                                            <select className="form-control" value={this.state.sort}
                                                    onChange={this.changeSort.bind(this)}>
                                                <option
                                                    value={"customer_product_date DESC"}>{ST.get("creation_date", "global")}</option>
                                                <option value={"customer_product_number ASC"}>A-Z</option>
                                                <option value={"customer_product_number DESC"}>Z-A</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="table-responsive">
                                <table className="table table-lg">
                                    <thead>
                                    <tr>
                                        <th className="text-left">{ST.get("serialNumber", "service")}</th>
                                        <th className="text-left">{ST.get("product_name", "product")}</th>
                                        <th className="text-left">{ST.get("date2", "service")}</th>
                                        <th className="text-left">{ST.get("warrantyDate", "service")}</th>

                                    </tr>
                                    </thead>
                                    <tbody>
                                    {tiles.map((element, index) => {
                                        return (<tr key={index}>
                                            <td><Link to={Session.getItem("basename") + "/service/" + element.id} >{element.serialNumber}</Link></td>
                                            <td>{element.name}</td>
                                            <td>{element.date}</td>
                                            <td>{element.warranty}</td>
                                            <td>{element.orderOur}</td>
                                        </tr>);
                                    })}

                                    </tbody>
                                </table>
                            </div>

                            <div className="text-center content-group-lg pt-20">
                                <ul className="pagination">
                                    <li className={this.state.page === 1 ? "disabled" : ""}><Button
                                        disabled={this.state.page === 1} onClick={() => {
                                        this.setState({page: (this.state.page - 1), loaded: false})
                                    }} size={"sm"} variant={"light"}><i className="icon-arrow-small-left"/></Button>
                                    </li>
                                    {paginations.map((element, index) => {
                                        return (element);
                                    })}
                                    <li className={this.state.page === pages ? "disabled" : ""}>
                                        <Button disabled={this.state.page === pages} onClick={() => {
                                            this.setState({page: (this.state.page + 1), loaded: false})
                                        }} size={"sm"} variant={"light"}><i
                                            className="icon-arrow-small-right"/></Button></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                )
            }else {
                return (
                    <div className="panel border-top-xlg" style={{borderColor: window.portalSettings.portal_pcolor}}>
                        <Breadcrumbs active={ST.get("service", "global")}/>
                        <div className="panel-heading no-padding-bottom">
                            <h3 className="panel-title">{ST.get("service", "global")}</h3>
                        </div>
                        <div className="panel-body empty-state" style={{
                            background: window.portalSettings.portal_pcolor + "4e",
                            fontSize: "17px",
                            fontWeight: "500"
                        }}>
                            <Row>
                                <Col md={12} style={{padding: "25px"}}>
                                    {ST.get("no_records_found", "global")}
                                </Col>
                            </Row>
                        </div>
                    </div>
                )
            }

        } else {
            return (<BubbleLoader color={window.portalSettings.portal_pcolor}/>);
        }
    }
}